import { Operation, Transaction } from 'types';

type GetPartnerTransactionsFromOperationProps = {
  operation: Operation;
  partnerId: string;
};

export const getPartnerTransactionsFromOperation = ({
  operation,
  partnerId,
}: GetPartnerTransactionsFromOperationProps): Transaction[] => {
  if (!operation?.transactions?.length) {
    return [];
  }

  return operation.transactions.filter(
    (transaction) => (transaction as Transaction)?.partner === partnerId
  ) as Transaction[];
};
